import { render, staticRenderFns } from "./StarterPage.vue?vue&type=template&id=7eb8eaae&scoped=true&"
import script from "./StarterPage.vue?vue&type=script&lang=js&"
export * from "./StarterPage.vue?vue&type=script&lang=js&"
import style0 from "./StarterPage.vue?vue&type=style&index=0&id=7eb8eaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb8eaae",
  null
  
)

export default component.exports